export default __webpack_public_path__ + "static/ilustration-0a5586e4fff9c39a76d6ed06ac19071d.jpg";